import {
  faFileCsv,
  faFileExcel,
  faFilePowerpoint,
  faFileWord,
  faTrash,
} from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ActionIcon, Center } from '@mantine/core'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { AssetProps } from '../../types/preview'
import { standarizedType } from '../../utils'
import DisplayImage from './DisplayImage'
import DisplayPdf from './DisplayPdf'
import DisplayVideo from './DisplayVideo'
import UndisplayableAsset from './UndisplayableAsset'

const Asset = ({
  asset,
  maxWidth,
  height,
  onDelete,
  index,
  openModal,
  modalOpen,
}: AssetProps): React.ReactElement => {
  const { t } = useTranslation('file_uploads')

  const openAssetInModal = (): void => {
    openModal(index)
  }

  return (
    <Center>
      <div style={{ width: maxWidth, position: 'relative' }}>
        {standarizedType(asset.type) === 'image' && (
          <DisplayImage
            asset={asset}
            maxWidth={maxWidth}
            height={height}
            openInModal={openAssetInModal}
            modalOpen={modalOpen}
          />
        )}
        {standarizedType(asset.type) === 'pdf' && (
          <DisplayPdf
            asset={asset}
            maxWidth={maxWidth}
            height={height}
            openInModal={openAssetInModal}
            modalOpen={modalOpen}
          />
        )}

        {standarizedType(asset.type) === 'video' && (
          <DisplayVideo
            asset={asset}
            maxWidth={maxWidth}
            height={height}
            openInModal={openAssetInModal}
            modalOpen={modalOpen}
          />
        )}

        {standarizedType(asset.type) === 'document' && (
          <UndisplayableAsset
            asset={asset}
            maxWidth={maxWidth}
            height={height}
            openInModal={openAssetInModal}
            modalOpen={modalOpen}
            icon={faFileWord}
            errorText={t('preview.corrupt_document')}
          />
        )}

        {standarizedType(asset.type) === 'csv' && (
          <UndisplayableAsset
            asset={asset}
            maxWidth={maxWidth}
            height={height}
            openInModal={openAssetInModal}
            modalOpen={modalOpen}
            icon={faFileCsv}
            errorText={t('preview.corrupt_csv')}
          />
        )}

        {standarizedType(asset.type) === 'sheet' && (
          <UndisplayableAsset
            asset={asset}
            maxWidth={maxWidth}
            height={height}
            openInModal={openAssetInModal}
            modalOpen={modalOpen}
            icon={faFileExcel}
            errorText={t('preview.corrupt_sheet')}
          />
        )}

        {standarizedType(asset.type) === 'presentation' && (
          <UndisplayableAsset
            asset={asset}
            maxWidth={maxWidth}
            height={height}
            openInModal={openAssetInModal}
            modalOpen={modalOpen}
            icon={faFilePowerpoint}
            errorText={t('preview.corrupt_powerpoint')}
          />
        )}

        {typeof onDelete === 'function' && !modalOpen && (
          <ActionIcon
            color="red"
            variant="filled"
            style={{
              position: 'absolute',
              bottom: 10,
              right: 10,
            }}
            onClick={() => onDelete(index)}
          >
            <FontAwesomeIcon icon={faTrash} style={{ color: 'white' }} />
          </ActionIcon>
        )}
      </div>
    </Center>
  )
}

export default Asset
